import { defineMessages } from 'react-intl'
import ptMessages from './pt.json'
import enMessages from './en.json'
import esMessages from './es.json'

export default {
  'pt': {
    data: ptMessages,
    messages: defineMessages(ptMessages),
  },
  'en': {
    data: enMessages,
    messages: defineMessages(enMessages),
  },
  'es': {
    data: esMessages,
    messages: defineMessages(esMessages),
  },
}



// WEBPACK FOOTER //
// ./src/i18n/index.js